import type { SetupWizardForm } from '../../types'

export const DEFAULT_SETUP_FORM: SetupWizardForm = {
  owner: {
    fullName: '',
    email: '',
    password: '',
    confirmPassword: '',
  },
  storeIdentity: {
    storeName: '',
    timezone: 'Europe/Rome',
    currency: 'EUR',
  },
  onboardingPreferences: {
    paymentStrategy: 'configure_later',
    emailProvider: 'configure_later',
    botProtection: 'configure_later',
  },
  paymentSetup: {
    providerId: 'configure_later',
    stripe: {
      stripeMode: 'test',
      publishableKey: '',
      secretKey: '',
      webhookSecret: '',
    },
    bankTransfer: {
      beneficiaryName: '',
      iban: '',
      bicSwift: '',
      bankName: '',
      paymentInstructions: '',
      paymentTimeoutDays: 5,
    },
  },
  emailSetup: {
    providerId: 'configure_later',
    smtp: {
      host: '',
      port: 587,
      secure: false,
      username: '',
      password: '',
      fromName: '',
      fromEmail: '',
      replyToEmail: '',
    },
  },
  botProtectionSetup: {
    providerId: 'configure_later',
  },
}
